import React from 'react';
import PropTypes from 'prop-types';
import CurrencyHelpers from 'lib/helpers/CurrencyHelpers';

const s = {
  container: {
    margin: 10,
    padding: 10,
    borderLeft: '2px solid #efefef',
    width: 400,
    maxWidth: '100%',
  },
  description: {
    margin: 0,
    color: '#000',
  },
  value: {
    margin: 0,
    color: '#999',
  },
};

const ServiceItem = ({ item, currencySymbol }) => (
  <div style={s.container}>
    <p style={s.description}>
      Description: <span style={s.value}>{item.description}</span>
    </p>
    <p style={s.description}>
      Amount:
      <span style={s.value}>{CurrencyHelpers.centsToDollars(item.amount, { symbol: currencySymbol })}</span>
    </p>
  </div>
);

export default ServiceItem;



// WEBPACK FOOTER //
// ./src/components/common/ContractComponent/ServicesAndPayment/ServicesProvided/ServiceItem/index.js